import React, { Component, Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { reduxForm } from 'redux-form';

import { connect } from 'react-redux';

import { getProperties, getAgents } from 'actions/landlordPropertiesActions';
import {
  createOrUpdateEscalationRule,
  getMaintenanceEscalationRules,
  deleteEscalationRule,
} from 'actions/maintenanceActions';

import PropertyMultiSelect from 'components/shared/PropertyMultiSelect';
import { RenderEscalationRule } from './components/escalation/RenderEscalationRule';
import { FormComponent } from './components/escalation/AddEscalationRuleForm';

import { AccentColor } from 'helpers/AccentColorHelper';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import FieldItems from 'components/shared/FieldItems/FieldItems';

import EscalationIcon from '@material-ui/icons/NotificationsActiveTwoTone';
import AddIcon from '@material-ui/icons/NoteAddTwoTone';

let LandlordMaintenanceEscalation = withMobileDialog()(
  connect(
    store => ({
      properties: store.landlordProperties.properties,
      agents: store.landlordProperties.agents,
      escalationRules: store.maintenanceReducer.escalationRules,
    }),
    {
      getProperties,
      getAgents,
      createOrUpdateEscalationRule,
      getMaintenanceEscalationRules,
      deleteEscalationRule,
    }
  )(
    class LandlordMaintenanceEscalation extends Component {
      constructor(props) {
        super(props);
        this.state = {
          selectedPropertyId: null,
          selectedPropertyMultiSelect: null,
        };
      }

      componentDidMount = () => {
        this.props.getProperties({ for_multiselect: true });
      };

      onPropertySelect = property => {
        let propertyValue = property;
        if (property) {
          this.props.getAgents();
          propertyValue = property.value;
          this.props.getMaintenanceEscalationRules(propertyValue);
        }

        this.setState({
          selectedPropertyId: propertyValue,
          selectedPropertyMultiSelect: property || {},
        });
      };

      createOrUpdateEscalationRule = async formData => {
        const escalationRules = { ...formData, property_id: this.state.selectedPropertyId };
        await this.props.createOrUpdateEscalationRule(escalationRules);
        this.props.getMaintenanceEscalationRules(this.state.selectedPropertyId);
      };

      deleteEscalationRule = async escalationDetails => {
        await this.props.deleteEscalationRule(escalationDetails.id);
        this.props.getMaintenanceEscalationRules(this.state.selectedPropertyId);
      };

      render() {
        return (
          <div className="body" role="main">
            <div className="centers">
              <div style={{ marginBottom: '5px' }}>
                <span className="page-title">Escalation</span>
                <span
                  style={{
                    color: AccentColor(),
                    fontFamily: 'Circular-Black',
                    fontSize: '25px',
                  }}
                >
                  .
                </span>
                {this.renderPropertySelect()}
              </div>
              <CSSTransitionGroup
                transitionName="fade_out_buttons"
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
              >
                {this.renderGetStarted()}
                <div
                  className="row"
                  style={{ height: '100%', textAlign: 'center', padding: '5vh 0 0' }}
                >
                  {this.renderNoEscalationRulesPresent()}
                  {this.renderEscalationRulesPresent()}
                  {this.renderAddEscalationRules()}
                </div>
              </CSSTransitionGroup>
            </div>
          </div>
        );
      }

      renderPropertySelect = () => (
        <div
          style={{
            width: '150px',
            display: 'inline-block',
            marginTop: '7px',
            float: 'right',
          }}
        >
          <PropertyMultiSelect
            onPropertySelect={this.onPropertySelect}
            properties={this.props.properties}
            selectedProperties={this.state.selectedPropertyMultiSelect}
            verbiage="Select a Property"
            disableMultiple
          />
        </div>
      );

      renderGetStarted = () => {
        if (this.state.selectedPropertyId) return;

        return (
          <div className="row" style={{ height: '100%', textAlign: 'center', padding: '10vh 0 0' }}>
            <EscalationIcon style={{ color: '#eaeaea', height: '30vh', width: '30vh' }} />
            <h4 style={{ fontFamily: 'Circular' }}> Choose a property to get started </h4>
          </div>
        );
      };

      renderNoEscalationRulesPresent = () => {
        if (!this.state.selectedPropertyId) return;
        if (this.props.escalationRules.length > 0) return;

        return (
          <Fragment>
            <AddIcon style={{ color: '#eaeaea', height: '20vh', width: '20vh' }} />
            <div className="row" style={{ textAlign: 'center', marginTop: '8px' }}>
              <h4
                style={{
                  width: '300px',
                  fontFamily: 'Circular',
                  textAlign: 'center',
                  margin: '0 auto 20px',
                }}
              >
                Hm - there aren&#39;t any rules yet for{' '}
                {this.state.selectedPropertyMultiSelect.label}. Add one by clicking the button
                below.
              </h4>
            </div>
          </Fragment>
        );
      };

      renderEscalationRulesPresent = () => {
        if (!this.state.selectedPropertyId) return;
        if (this.props.escalationRules.length === 0) return;

        return (
          <h3 style={{ marginBottom: '20px' }}>
            {this.state.selectedPropertyMultiSelect.label} Escalation Rules
          </h3>
        );
      };

      renderAddEscalationRules = () => {
        if (!this.state.selectedPropertyId) return;

        return (
          <div className="row" style={{ marginBottom: '30px' }}>
            <FieldItems
              name="maintenance_escalation"
              formName={this.props.form}
              renderSavedItems={RenderEscalationRule}
              renderForm={FormComponent}
              dialogHeader="Add Escalation Rule"
              buttonVerbiageOverride="Add Escalation Rule"
              formProps={{ agents: this.props.agents }}
              onSave={this.createOrUpdateEscalationRule}
              onDelete={this.deleteEscalationRule}
            />
          </div>
        );
      };
    }
  )
);

LandlordMaintenanceEscalation = reduxForm({
  form: 'add_maintenance_escalation_form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
})(LandlordMaintenanceEscalation);

export default connect(store => ({
  initialValues: { maintenance_escalation: store.maintenanceReducer.escalationRules },
}))(LandlordMaintenanceEscalation);
